import { Material } from '../interfaces/material';
import axios from '../config/axios';

const API_PATH = '/materiales';

interface ListParams {
  take?: number;
  skip?: number;
  orderBy?: string;
  orderCriterio?: 'ASC' | 'DESC';
  descripcion?: string;
}

class MaterialService {
  async list(params?: ListParams): Promise<[Material[], number]> {
    const response = await axios.get(API_PATH, { params });
    return [response.data, response.data.length];
  }

  async getById(id: number): Promise<Material> {
    const response = await axios.get(`${API_PATH}/${id}`);
    return response.data;
  }
}

export default new MaterialService();
